<script setup>
import { ref, inject, onMounted, onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'dashboard/composables/store';
import { useAlert, useTrack } from 'dashboard/composables';
import { CAMPAIGN_TYPES } from 'shared/constants/campaign.js';
import { CAMPAIGNS_EVENTS } from 'dashboard/helper/AnalyticsHelper/events.js';

import WhatsAppEvoCampaignForm from 'dashboard/components-next/Campaigns/Pages/CampaignPage/WhatsAppEvoCampaign/WhatsAppEvoCampaignForm.vue';
import Button from 'dashboard/components-next/button/Button.vue';

const emit = defineEmits(['close']);
const showDialog = ref(true);
const store = useStore();
const { t } = useI18n();
const dialogGuard = inject('campaignDialogGuard', ref({ isModalOpen: false }));

const addCampaign = async campaignDetails => {
  try {
    await store.dispatch('campaigns/create', campaignDetails);

    useTrack(CAMPAIGNS_EVENTS.CREATE_CAMPAIGN, {
      type: CAMPAIGN_TYPES.ONE_OFF,
    });

    useAlert(t('CAMPAIGN.WHATSAPP_EVO.CREATE.FORM.API.SUCCESS_MESSAGE'));
  } catch (error) {
    const errorMessage =
      error?.response?.message ||
      t('CAMPAIGN.WHATSAPP_EVO.CREATE.FORM.API.ERROR_MESSAGE');
    useAlert(errorMessage);
  }
};

const handleSubmit = campaignDetails => {
  addCampaign(campaignDetails);
};

const handleClose = () => {
  showDialog.value = false;
  dialogGuard.value.isModalOpen = false;
  emit('close');
};

onMounted(() => {
  dialogGuard.value.isModalOpen = true;
  store.dispatch('agents/get');
  // [PROSPEK] 2025-11-29 Load custom attributes for audience builder filters
  store.dispatch('attributes/get');
  // [/PROSPEK]
});

onBeforeUnmount(() => {
  dialogGuard.value.isModalOpen = false;
});
</script>

<template>
  <Teleport to="body">
    <woot-modal
      v-model:show="showDialog"
      size="medium"
      :on-close="handleClose"
      :show-close-button="false"
      close-on-backdrop-click
    >
      <!-- [PROSPEK] 2026-03-11 Custom header with close button on right (woot-modal ltr:right-2 requires dir attr) -->
      <div class="relative w-full">
        <div
          class="flex items-center justify-between px-8 pt-6 pb-4 border-b border-n-weak"
        >
          <h2 class="text-base font-semibold leading-6 text-n-slate-12">
            {{ t('CAMPAIGN.WHATSAPP_EVO.CREATE.TITLE') }}
          </h2>
          <Button ghost slate icon="i-lucide-x" @click="handleClose" />
        </div>
        <!-- [/PROSPEK] -->
        <div class="px-8 py-6 overflow-y-auto max-h-[calc(100vh-12rem)]">
          <WhatsAppEvoCampaignForm
            @submit="handleSubmit"
            @cancel="handleClose"
          />
        </div>
      </div>
    </woot-modal>
  </Teleport>
</template>
